import type { ComponentType, FC, ReactNode } from 'react'
import type { ConsortiumSlug } from '@/types'

import { CarFront, House, Sparkles, Truck } from 'lucide-react'

interface IconProps {
    className?: string
    'aria-hidden'?: boolean | 'true' | 'false'
}

interface ConsortiumIconProps extends IconProps {
    slug: ConsortiumSlug
}

const Motorcycle: FC<IconProps> = ({ className }): ReactNode => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
            className={className}
        >
            <circle cx='5.5' cy='16.5' r='3.5' />
            <circle cx='18.5' cy='16.5' r='3.5' />
            <path d='M18.5 16.5 15.5 7h-2' />
            <path d='M5.5 16.5 9 11h7.6' />
            <path d='m9 11 2 5.5h4' />
        </svg>
    )
}

const icons: Record<ConsortiumSlug, ComponentType<IconProps>> = {
    imoveis: House,
    automoveis: CarFront,
    motos: Motorcycle,
    pesados: Truck,
    servicos: Sparkles
}

export const ConsortiumIcon: FC<ConsortiumIconProps> = ({ slug, className }): ReactNode => {
    const Icon = icons[slug]

    return <Icon className={className} aria-hidden='true' />
}
